import { gql, InternalRefetchQueriesInclude, useMutation } from '@apollo/client'

const doc = gql`
  mutation ApproveStoreOrder($storeOrderId: String!, $notes: String!, $sendEmail: Boolean!) {
    approveStoreOrder(storeOrderId: $storeOrderId, notes: $notes, sendEmail: $sendEmail)
  }
`

type Vars = {
  storeOrderId: string
  notes: string
  sendEmail: boolean
}

type Data = {
  approveStoreOrder: boolean
}

const useApproveStoreOrder = (refetchQueries?: InternalRefetchQueriesInclude) =>
  useMutation<Data, Vars>(doc, { refetchQueries })

export default useApproveStoreOrder
